module.exports = __webpack_public_path__ + "img/m-start-front.330d699e.jpg";